import {
  TimetablePrintColorOrigins,
  TimetablePrintColorPositions,
  TimetablePrintLayoutOptions,
  TimetableReportType,
} from '@bp/planung-graphql-types';
import {
  TimetablePrintBaseData,
  TimetablePrintLayoutData,
} from '../components/TimetablePrintConfiguration/forms/TimetablePrintConfigurationForm';

export const timetablePrintColorDefaults: Record<TimetableReportType, Omit<TimetablePrintBaseData, 'color'>> = {
  attendanceSchedule: {
    colorOrigin: TimetablePrintColorOrigins.None,
    colorPosition: TimetablePrintColorPositions.Full,
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  allClasses: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Teacher,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  allSubjects: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Class,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  allRooms: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Teacher,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  allTeachers: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Class,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  singleSubject: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Class,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  singleRoom: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Teacher,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  singleClass: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Subject,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  singleTeacher: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Class,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  teachingBlocksSubject: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Class,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  teachingBlocksTeacher: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Subject,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  teachingBlocksRoom: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Subject,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  teachingBlocksClass: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Subject,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  doorSigns: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Teacher,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
  schoolTrips: {
    exactMinute: true,
    printClasses: true,
    printLogo: false,
    scaleText: true,
    printSubtitle: true,
    colorPosition: TimetablePrintColorPositions.Full,
    colorOrigin: TimetablePrintColorOrigins.Teacher,
    largeFont: true,
    showSchoolWeeks: false,
    showCalendarWeeks: true,
    showWeekSchoolDays: false,
    timeHorizontal: false,
  },
};

export const timetablePrintLayoutDefaults: Record<TimetableReportType, TimetablePrintLayoutData> = {
  allClasses: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.Empty,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.TeacherLong,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.GroupName,
  },
  allSubjects: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.Empty,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.Empty,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.Empty,
  },
  allRooms: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.ClassName,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.TeacherLong,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.GroupName,
  },
  allTeachers: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.Empty,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.TeacherLong,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.GroupName,
  },
  singleSubject: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.Empty,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.Empty,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.Empty,
  },
  singleRoom: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.ClassName,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.TeacherLong,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.GroupName,
  },
  singleClass: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.RoomName,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.TeacherLong,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.GroupName,
  },
  singleTeacher: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.RoomName,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.ClassName,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.GroupName,
  },
  teachingBlocksSubject: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.Empty,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.Empty,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.Empty,
  },
  teachingBlocksTeacher: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.RoomName,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.ClassName,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.Empty,
  },
  teachingBlocksRoom: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.RoomName,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.ClassName,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.Empty,
  },
  teachingBlocksClass: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.RoomName,
    bottomRight: TimetablePrintLayoutOptions.GroupName,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.TeacherLong,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.Empty,
  },
  doorSigns: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.SubjectLong,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.TeacherLong,
    topLeft: TimetablePrintLayoutOptions.ClassName,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.GroupName,
  },
  attendanceSchedule: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.Empty,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.Empty,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.Empty,
  },
  schoolTrips: {
    bottomCenter: TimetablePrintLayoutOptions.Empty, // center2ndLine
    bottomLeft: TimetablePrintLayoutOptions.Empty,
    bottomRight: TimetablePrintLayoutOptions.Empty,
    center: TimetablePrintLayoutOptions.SubjectLong,
    topLeft: TimetablePrintLayoutOptions.Empty,
    topCenter: TimetablePrintLayoutOptions.Empty,
    topRight: TimetablePrintLayoutOptions.Empty,
  },
};
